import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

export interface PlaceCommand {
  location: {
    id: string;
    name: string;
  };
}

const client = createClient('/rest/operator-api/charging-stations');

export const place: SaveOperation<PlaceCommand, void, string> = postRequestFactory<PlaceCommand, void, string>(
  client,
  {
    pattern: '/{chargingStationId}/place',
    permissionId: commandPermissions.PLACE_CHARGING_STATION
  }
);
